import { render, staticRenderFns } from "./ModalAddPoint.vue?vue&type=template&id=a20783da&"
import script from "./ModalAddPoint.vue?vue&type=script&lang=js&"
export * from "./ModalAddPoint.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddPoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports